"use client";
import { jsx } from "react/jsx-runtime";
import { DropdownTextItem } from "../../primitive-dropdown/dropdown-text-item.js";
import { AsyncGenericDropdown } from "./async-generic-dropdown.js";
function AsyncTextsDropdown({ options, multiline, ...props }) {
    const textOptions = options.map((option)=>({
            value: option.value,
            label: option.label,
            description: option.description,
            element: (elementProps)=>/*#__PURE__*/ jsx(DropdownTextItem, {
                    text: option.label,
                    description: option.description,
                    multiline: multiline,
                    ...elementProps
                })
        }));
    return /*#__PURE__*/ jsx(AsyncGenericDropdown, {
        ...props,
        multiline: multiline,
        options: textOptions
    });
}
export { AsyncTextsDropdown };
